import { gql } from 'urql';

/**
 * Trimmed, dedicated version of the `pinwheelFlowPage` query that only
 * requests `__typename`. Used when the caller only needs to distinguish
 * `DdPinwheelSetupPage` from other result types, without paying for the
 * full `DdManagementPage` field set fetched by `PinwheelFlow.query.ts`.
 */
const PinwheelFlowTypename = gql`
  query pinwheelFlowPageTypename {
    pinwheelFlowPage {
      __typename
    }
  }
`;

export default PinwheelFlowTypename;
